import { useCallback, useState } from 'react'
import { IUseChipsCore } from './types'

export const useChipsCore: IUseChipsCore = (props) => {
  const { onClick } = props
  const [rendering, setRendering] = useState(true)

  /** Клик на крестик очистки */
  const onClear = useCallback(
    (e) => {
      if (onClick) onClick(e)

      setRendering(false)
    },
    [onClick]
  )

  return {
    rendering,
    onClear,
  }
}
